import React from 'react';
import { Card, AlertText, ExamApplicationStatus } from 'components';
import { IRootState, Dispatch } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { useLocalErrorHandler } from 'hooks';
import { FilteredExamStatus } from '../../api/ApiClient';
import { ProfileInfoTabContainer } from './ProfileInfoTabContainer';
import { DocsTabContainer } from './DocsTabContainer';
import identificationIcon from 'components/assets/svg/identification_icon.svg';
import docsIcon from 'components/assets/svg/documents_icon.svg';
import styles from './ExamDraftContainer.module.scss';
import cn from 'classnames';

const ExamDraftContainer = ({
    examApplicationId,
    setErrorHandler,
    examList,
    apiError,
    onPush,
    clearApplicationDetails,
    clearApplicantDetail,
    getExams,
    fetchExamApplicationDetails,
    applicationDetails,
    applicantDetail,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    React.useEffect(() => {
        clearApplicationDetails();
        clearApplicantDetail();

        return () => {
            clearState();
            clearApplicationDetails();
            clearApplicantDetail();
        };
    }, []);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);

            await getExams({ filteredExamStatus: FilteredExamStatus.IsApplying });

            // if (examApplicationId) {
            //     await fetchExamApplicationDetails(examApplicationId);
            // }

            setProcessing(false);
        };

        fetch();
    }, []);

    // React.useEffect(() => {
    //     const fetch = async () => {
    //         setProcessing(true);
    //         if (examApplicationId) {
    //             await fetchExamApplicationDetails(examApplicationId);
    //         }
    //         setProcessing(false);
    //     };

    //     fetch();
    // }, [examApplicationId]);

    React.useEffect(() => {
        if (examApplicationId) {
            const params = new URLSearchParams(window.location.search);
            const param = params.get('tab');
            const newTab = param && (param === TabType.Profile || param === TabType.Doc) ? param : null;

            setTab(newTab || TabType.Profile);
        }
    }, [examApplicationId]);

    const [processing, setProcessing] = React.useState(false);
    const [tab, setTab] = React.useState(TabType.Profile);

    const params = new URLSearchParams(window.location.search);
    const applicantPhone = params.get('applicant-phone');
    const examId = params.get('examId');
    const applicantId = React.useMemo(() => (applicantDetail ? applicantDetail.id : undefined), [applicantDetail]);

    const clearState = () => {
        setProcessing(false);
        setTab(TabType.Profile);
    };

    const onCancel = () => {
        clearApplicationDetails();
        clearApplicantDetail();
        if (examId) {
            onPush(`/exam/${examId}?from=exam-list`);
        } else {
            onPush('/exam-applications?tab=draft');
        }
    };

    const onBackClick = () => {
        const paramExamId = params.get('examId');

        if (examApplicationId) {
            onPush(`/exam-draft/${examApplicationId}?${examId ? `examId=${paramExamId}` : ''}`);
        } else {
            setTab(TabType.Profile);
        }
    };

    const exam = examList && examId ? examList.items.find(examItem => examItem.id === examId) : null;
    const qualificationTitle = exam ? `Подача заявки: «${exam.qualificationTitle}»` : null;

    return (
        <Card
          title={qualificationTitle || (examApplicationId ? 'Редактирование заявки на экзамен' : 'Создание заявки на экзамен')}
          onClickBack={examApplicationId ? onCancel : undefined}
          showLoader={processing}
          withBackButton={!!examApplicationId}
          apiError={tab === TabType.Profile ? apiError : null}
          smallTitle
          withoutPadding
        >
            <div className={styles.tabContainer}>
                <div className={cn(styles.tabContainer_tab, styles.tabContainer_tab_complete)}>
                    <img src={identificationIcon} alt="identificationIcon" />
                    <span className="pl-2">Удостоверение личности</span>
                </div>
                <div className={cn(styles.tabContainer_tab, tab === TabType.Doc && styles.tabContainer_tab_complete)}>
                    <img src={docsIcon} alt="docsIcon" />
                    <span className="pl-2">Сканы документов</span>
                </div>
            </div>

            {applicationDetails && applicationDetails.status === ExamApplicationStatus.CorrectionsRequired ? (
                <AlertText title="В текущую заявку требуется внести следующие исправления:" text={applicationDetails.reviewComment || ''} />
            ) : null}

            {tab === TabType.Profile ? (
                <Card withoutBorder>
                    <ProfileInfoTabContainer
                      applicantId={applicantId}
                      examId={examId}
                      phone={applicantPhone}
                      examApplicationId={examApplicationId}
                      onCancel={onCancel}
                    />
                </Card>
            ) : null}

            {tab === TabType.Doc ? (
                <Card cardClassName="mb-0" withoutBorder>
                    <DocsTabContainer onSuccessSubmit={onCancel} onBackClick={onBackClick} />
                </Card>
            ) : null}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    applicantDetail: state.applicants.applicantDetail,
    examList: state.exam.examList,
    apiError: state.errors.error,
    applicationDetails: state.examApplications.applicationDetails,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getExams: dispatch.exam.getExamsAsync,
    fetchExamApplicationDetails: dispatch.examApplications.fetchExamApplicationDetailsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    clearApplicationDetails: dispatch.examApplications.clearApplicationDetails,
    clearApplicantDetail: dispatch.applicants.clearApplicantDetail,
});

export default connect(mapState, mapDispatch)(ExamDraftContainer);

interface IProps {
    examApplicationId?: string;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
type Props = connectedProps & IProps;

enum TabType {
    Profile = 'profile',
    Doc = 'doc'
}
